<template>
    <div class="w-full lg:w-[300px] 2xl:w-[465px] relative flex flex-row flex-wrap border-r">
        <confirmation-tooltip :visible="confirmationTooltip"/>

        <div class="bg-primary lg:h-[150px] w-full shadow-md">
            <div class="p-2 2xl:p-4 lg:h-[100px] flex content-center flex-row flex-wrap">
                <div class="h1 text-white mb-0 w-full text-[30px] lg:text-[34px] 2xl:text-[38px]">
                    Build <span class="hidden 2xl:inline-block">Your</span> Leads List!
                </div>
                <p class="text-white text-[12px] mb-0 w-full">High Value Audiences</p>
            </div>
            <div class="grid grid-cols-2 bg-primary-tab-widget">
                    <span
                        class="p-2 lg:h-[50px] text-white text-opacity-50 flex justify-center items-center cursor-pointer hover:text-opacity-100"
                        :class="[{'bg-primary-tab-widget-active text-opacity-100': activeTab === 'geography'}]"
                        @click="changeTab('geography')">Geography</span>
                <span
                    class="p-2 lg:h-[50px] text-white text-opacity-50 flex justify-center items-center cursor-pointer hover:text-opacity-100"
                    :class="[{'bg-primary-tab-widget-active text-opacity-100': activeTab === 'selections'}]"
                    @click="changeTab('selections')">
                        {{ changeTabButtonText }}
                    </span>
            </div>
        </div>

        <div class="overflow-y-auto p-2 2xl:p-4 lg:h-[calc(100%-200px)] w-full">
            <audience v-show="activeTab === 'geography'"/>
            <geography v-show="activeTab === 'geography'"/>
            <selections v-show="activeTab === 'selections'"/>
        </div>

        <div class="w-full h-[50px] border-t">
            <div
                class="justify-between items-center relative h-full px-2 pl-14"
                :class="[{'hidden': activeTab !== 'geography'}, {'flex': activeTab === 'geography'}]">
                <span class="label-step left-0">3</span>
                <div class="uppercase text-[12px]">Next step:</div>
                <button type="button"
                        class="btn btn-orange bg-fully uppercase disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300"
                        @click="changeTab('selections', true)">
                    {{ changeTabButtonText }}
                </button>
            </div>

            <div class="justify-between items-center relative h-full px-2"
                 :class="[{'hidden': activeTab !== 'selections'}, {'flex': activeTab === 'selections'}]">
                <div class="uppercase text-[12px]">Next step:</div>
                <button type="button" class="btn btn-orange bg-fully" @click="focusLead()">
                    CHOOSE QUANTITY
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from "@widget/plugins/event-bus";
    import audience from "@widget/components/audience";
    import geography from "@widget/components/geography";
    import selections from "@widget/components/selections";
    import confirmationTooltip from "@widget/components/confirmation-tooltip";

    export default {
        name: "sidebar",
        components: {
            geography,
            audience,
            selections,
            confirmationTooltip
        },
        computed: {
            changeTabButtonText () {
                return this.$store.getters["widgetData/selectedData"].audience === this.$widgetConfig.b2cBase ? "Demographics" : "Firmographics";
            },
            confirmationTooltip () {
                return this.$store.getters["others/getConfirmationTooltip"];
            }
        },
        methods: {
            focusLead () {
                this.$scrollTo("body", 500, { offset: 0 });
                EventBus.$emit("focus-input-lead");
            },
            changeTab (payload, scroll = false) {
                this.activeTab = payload;
                if (scroll) {
                    let offset = 0;
                    this.$scrollTo("body", 500, { offset });
                }
            }
        },
        data () {
            let treatment = this.$store.getters["others/getTreatment"]("toggle_firmographics");
            return {
                activeTab: treatment && treatment === "on" ? "selections" : "geography"
            };
        },
        mounted () {
            EventBus.$on("edit-select", () => {
                this.activeTab = "selections";
            });
        }
    };
</script>
